import { ElementRef, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class NgxPhotoswipeService {
    lightboxElement: ElementRef;
}
